'use client';

import { cn } from '@core/utils';

import { AD_PLACEMENTS } from './adPlacements';
import { BannerAdSlot } from './BannerAdSlot';

interface DesktopSideAdBannerProps {
  className?: string;
  footer?: React.ReactNode;
}

//* aside는 광고 유무와 무관하게 항상 렌더해 PC 우측 250 칼럼을 예약한다 (footer도 표시).
export const DesktopSideAdBanner = ({
  className,
  footer,
}: DesktopSideAdBannerProps) => (
  <aside
    className={cn('hidden w-250 shrink-0 flex-col gap-16 xl:flex', className)}
  >
    <BannerAdSlot {...AD_PLACEMENTS.homeSide} />
    {footer}
  </aside>
);
